import React from 'react'

import './CountryWithFlag.scss'

const CountryWithFlag = ({ name, flag_url, short_name }) => {
    return (
        <div className="CountryWithFlag__Cont">
            <img alt={`${name} flag`} src={flag_url} className="country_flag" />
            <div className="country country_long">{name}</div>
            <div className="country country_short">{short_name}</div>
        </div>
    )
}

export default CountryWithFlag
